import { base, bsc, bscTestnet, mainnet, sepolia, SupportedChainId } from '@packet/constants/AppSupportChains';
import { Hash } from 'viem';

export const ChainConfigMap: Record<SupportedChainId, { appContract: Hash; freezeApiUrl: string; relayerApiUrl: string }> = {
  [sepolia.id]: {
    appContract: import.meta.env.VITE_ETH_SEPOLIA_APP_CONTRACT as Hash,
    freezeApiUrl: import.meta.env.VITE_ETH_SEPOLIA_API_FREEZE_URL,
    relayerApiUrl: import.meta.env.VITE_ETH_SEPOLIA_API_RELAYER_URL,
  },
  [bscTestnet.id]: {
    appContract: import.meta.env.VITE_BSC_TESTNET_APP_CONTRACT as Hash,
    freezeApiUrl: import.meta.env.VITE_BSC_TESTNET_API_FREEZE_URL,
    relayerApiUrl: import.meta.env.VITE_BSC_TESTNET_API_RELAYER_URL,
  },
  [mainnet.id]: {
    appContract: import.meta.env.VITE_ETH_APP_CONTRACT as Hash,
    freezeApiUrl: import.meta.env.VITE_ETH_API_FREEZE_URL,
    relayerApiUrl: import.meta.env.VITE_ETH_API_RELAYER_URL,
  },
  [bsc.id]: {
    appContract: import.meta.env.VITE_BSC_APP_CONTRACT as Hash,
    freezeApiUrl: import.meta.env.VITE_BSC_API_FREEZE_URL,
    relayerApiUrl: import.meta.env.VITE_BSC_API_RELAYER_URL,
  },
  [base.id]: {
    appContract: import.meta.env.VITE_BASE_APP_CONTRACT as Hash,
    freezeApiUrl: import.meta.env.VITE_BASE_API_FREEZE_URL,
    relayerApiUrl: import.meta.env.VITE_BASE_API_RELAYER_URL,
  },
};
